<template>
    <ul class="counters">
        <li class="flex-all" v-for="label in matches">
            <div class="title">
                <div class="bold">
                    <div>{{ label.title }}</div>

                    <h6 class="bold">
                        {{ label.text }}
                        <span v-if="product"> | {{ formatPrice(label.value) }}€</span>
                    </h6>
                </div>
            </div>

            <calculator :object="label" field="quantity" @mathDone="mathDone" :editable="editable"></calculator>
        </li>
    </ul>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Calculator from './Calculator'

    export default {
        props: {
            editable: {
                type: Boolean,
                default: true,
            }
        },
        data: function() {
            return {
                form: {},
                matches: [],
            }
        },
        created: function() {
            if (this.getClonedReservation) {
                this.form = JSON.parse(JSON.stringify(this.getClonedReservation));
            }

            this.getPeopleLabels.forEach(label => {
                let found = this.product.prices.find(p => p.audienceType === label.id);

                if (found) {
                    this.matches.push({ ...label, ...found });
                }
            });
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'getPeopleLabels',
            ]),
            product: function() {
                return this.form.event.product;
            },
        },
        methods: {
            ...mapActions([
                'updateClonedReservation'
            ]),
            mathDone: function(data) {
                console.log('mathDone on PriceCounters with', data);

                // Update targeted match with the new value for the UI and then update
                // the actual clonedReservation price quantity as well

                let found = this.matches.find(m => data.object.id === m.id);

                if (found) {
                    let actualPrice = this.product.prices.find(p => data.object.id === p.id);

                    if (actualPrice) {
                        found.quantity = data.value;
                        actualPrice.quantity = data.value;
                    }
                }

                this.$emit('updatePrices', this.product.prices);
            }
        },
        components: {
            Calculator
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .counters {
        display: flex;
        background: $faded;
        border: 1px solid $light;
        border-top: 0;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;

        > li {
            text-align: center;
            padding: 1rem;
            border-left: 1px solid $light;

            &:first-child {
                border-left: 0;
            }

            h6 {
                color: $dark;
            }
        }

        .calculator {
            margin-top: 1rem;
            font-size: $font-size-larger;
        }
    }
</style>



// WEBPACK FOOTER //
// PriceCounters.vue?502dba31